
<div class="panel" *ngIf="dossiers && dossiers.length > 0">
  <h2>
    Dossiers supplémentaires
    <span style="font-size: 14px; color: #383838;">({{ requiredDossiers }} champs non assignés)</span>
  </h2>

  <table>
    <thead>
      <tr>
        <th style="border-top-left-radius: 0">Champ racine</th>
        <th style="width: 250px">Dossier assigné</th>
        <th style="width: 50px; border-top-right-radius: 0"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let dossier of dossiers" (click)="onSelect(dossier)">
        <td name="Champ racine">
          {{ dossier.root_field }}
        </td>
        <td name="Dossier assigné" style="width: 250px">
          {{ dossier?.dossier?.name || '-' }}
        </td>
        <td style="width: 50px;" class="actions">
          <a class="action-btn">
            <t-icon name="search"></t-icon>
          </a>
        </td>
      </tr>
    </tbody>  
  </table>

</div>
